// 呼び出し元 (views/welcome/index) はディスパッチャが turbolinks:load の中から呼ぶため、
// ここで改めて turbolinks:load を待つ必要はない (@see cardSlider.js の同じコメント、#2935)。
export default () => {
    const districts = ['hokkaido', 'tohoku', 'kanto', 'chubu', 'kinki', 'chugoku', 'shikoku', 'kyushu', 'okinawa' ]
    districts.forEach((district) => {
        const mapTargets = document.querySelectorAll(`.${district}`)

        mapTargets.forEach((mapTarget) => {
            mapTarget.addEventListener('mouseenter', () => {
                mapTargets.forEach((target) => {
                    target.classList.add('fill-color')
                })
            })
            mapTarget.addEventListener('mouseleave', () => {
                mapTargets.forEach((target) => {
                    target.classList.remove('fill-color')
                })
            })
        })
    })
}
